import React, { useEffect } from "react";

import DateFnsUtils from "@date-io/date-fns";
import "date-fns";

import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { IconButton, InputAdornment } from "@material-ui/core";

import ClearIcon from "@material-ui/icons/Clear";

import { CustomDateTimePicker, CalenderIcon } from "./styles";

interface dateProps {
  errorType?: string;
  handelChangeParent: (date: any) => void;
  time: string;
  width?: number;
  disabled?: boolean;
  normal?: boolean;
  defaultTime?: { hours: number; minutes: number };
}

export default function MaterialUIPickers({
  errorType,
  handelChangeParent,
  time,
  width,
  disabled,
  normal,
  defaultTime,
}: dateProps) {
  const initialDate = React.useMemo(() => {
    if (defaultTime) {
      const d = new Date();
      d.setHours(defaultTime.hours, defaultTime.minutes, 0, 0);
      return d;
    }
    return undefined;
  }, [defaultTime]);

  useEffect(() => {
    setSelectedDate(time ? new Date(time) : null);
    // eslint-disable-next-line
  }, [time, disabled]);

  const [selectedDate, setSelectedDate] = React.useState<Date | null>();

  const handleDateChange = (date: Date | null) => {
    if (disabled) {
      const now = new Date();
      if (defaultTime) {
        now.setHours(defaultTime.hours, defaultTime.minutes, 0, 0);
      }
      setSelectedDate(now);
      handelChangeParent(String(now));
      return;
    }

    if (date && defaultTime && !selectedDate) {
      const updatedDate = new Date(date);
      updatedDate.setHours(defaultTime.hours, defaultTime.minutes, 0, 0);
      setSelectedDate(updatedDate);
      handelChangeParent(String(updatedDate));
    } else {
      setSelectedDate(date);
      handelChangeParent(date ? String(date) : "");
    }
  };

  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <CustomDateTimePicker
        autoOk
        value={selectedDate}
        onChange={handleDateChange}
        initialFocusedDate={initialDate}
        format="dd-MM-yyyy    hh:mm a"
        inputVariant="outlined"
        size="small"
        width={width}
        disablePast
        disabled={disabled}
        helperText={null}
        error={Boolean(errorType)}
        leftArrowButtonProps={{ "aria-label": "Prev month" }}
        rightArrowButtonProps={{ "aria-label": "Next month" }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              {Boolean(selectedDate) && !disabled && (
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedDate(null);
                    handelChangeParent("");
                  }}
                  title="Clear date and time"
                  style={{ padding: 4, marginRight: 2 }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              )}
              <IconButton size="small">
                <CalenderIcon />
              </IconButton>
            </InputAdornment>
          ),
          style: { background: `${disabled ? "#F0F0F0" : ""}` }
        }}
      />
    </MuiPickersUtilsProvider>
  );
}
